import React, { useEffect, useState } from "react";
import { useBlocker, useNavigate, useParams } from "react-router-dom";
import {
    Alert,
    Badge,
    Box,
    Button,
    Chip,
    Collapse,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    Fab,
    Paper,
    Tab,
    Tabs,
    Tooltip,
    Typography
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

// tabs
import PersonalInformationTab from "pages/EmployeeWorkspace/components/Tabs/components/PersonalInformationTab";
import FamilyBackgroundTab from "pages/EmployeeWorkspace/components/Tabs/components/FamilyBackgroundTab";
import EducationalBackgroundTab from "pages/EmployeeWorkspace/components/Tabs/components/EducationalBackgroundTab";
import CivilServiceTab from "pages/EmployeeWorkspace/components/Tabs/components/CivilServiceTab";
import WorkExperienceTab from "pages/EmployeeWorkspace/components/Tabs/components/WorkExperienceTab";
import VoluntaryInvolvementTab from "pages/EmployeeWorkspace/components/Tabs/components/VoluntaryInvolvementTab";
import SpecialSkillsTab from "pages/EmployeeWorkspace/components/Tabs/components/SpecialSkillsTab";
import TrainingAttendedTab from "pages/EmployeeWorkspace/components/Tabs/components/TrainingAttendedTab";
import CharacterReferencesTab from "pages/EmployeeWorkspace/components/Tabs/components/CharacterReferencesTab";
import AssociationTab from "pages/EmployeeWorkspace/components/Tabs/components/AssociationTab";

import usePerson from "hooks/usePerson";
import NotFound from "pages/EmployeeWorkspace/components/NotFound";
import EmployeeHeader from "pages/EmployeeWorkspace/components/EmployeeHeader";
import AchievementAwards from "pages/EmployeeWorkspace/components/Tabs/components/AchievementAwards";
import {
    CardGiftcard,
    ConstructionOutlined,
    Diversity3Outlined,
    EngineeringOutlined,
    FamilyRestroomOutlined,
    HourglassBottom,
    PersonOutlineOutlined,
    SchoolOutlined,
    Search
} from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import workExperienceResource from "pages/EmployeeWorkspace/Resources/workExperienceResource";
import familyMemberResource from "pages/EmployeeWorkspace/Resources/familyMemberResource";
import civilServiceResource from "pages/EmployeeWorkspace/Resources/civilServiceResource";
import voluntaryWorkResource from "pages/EmployeeWorkspace/Resources/voluntaryWorkResource";
import trainingAttendedResource from "pages/EmployeeWorkspace/Resources/trainingAttendedResource";
import specialSkillResource from "pages/EmployeeWorkspace/Resources/specialSkillResource";
import achievementAwardResource from "pages/EmployeeWorkspace/Resources/achievementAwardResource";
import characterReferenceResource from "pages/EmployeeWorkspace/Resources/characterReferenceResource";
import associationResource from "pages/EmployeeWorkspace/Resources/associationResource";
import otherInfoResource from "pages/EmployeeWorkspace/Resources/otherInfoResource";
import { useFormValidation } from "hooks/useFormValidation";
import { personalInfoRules } from "pages/EmployeeWorkspace/validation/personInfoRules";
import { usePermission } from "hooks/usePermission";
import { useSelector } from "react-redux";
import DButton from "components/common/DButton";
import CompensationTab from "pages/EmployeeWorkspace/components/Tabs/components/CompensationTab";
import reportService from "services/report/reportService";
import PdfReportViewer from "components/Report/PdfReportViewer";

const getCount = (data, field) => {
    if (data && data[field]?.length) {
        return (
            <IconButton
                sx={{
                    backgroundColor: "rgba(194, 89, 83, 0.08)",
                    fontSize: 12,
                    height: 20,
                    width: 20,
                    color: "#C25953",
                    marginLeft: "2px"
                }}
            >
                <Badge color="primary">{data[field]?.length}</Badge>
            </IconButton>
        );
    }
    return null;
};

const tabIconStyle = { sx: { fontSize: 20 } };

const profileTabs = (
    data,
    { hasPayrollAccess, hasEmployeeAccess, hasOwnerAccess }
) => [
    {
        label: "Personal Information",
        icon: PersonOutlineOutlined, //<PersonOutlineOutlined {...tabIconStyle} />,
        count: getCount(data, ""),
        show: true
    },
    {
        label: "Family Background",
        icon: familyMemberResource.icon, //<FamilyRestroomOutlined {...tabIconStyle} />,
        count: getCount(data, "familyMembers"),
        show: hasEmployeeAccess || hasOwnerAccess
    },
    {
        label: "Educational Background",
        icon: workExperienceResource.icon, //<SchoolOutlined {...tabIconStyle} />,
        count: getCount(data, "educationBackgrounds"),
        show: hasEmployeeAccess || hasOwnerAccess
    },
    {
        label: "Civil Service Eligibility",
        icon: civilServiceResource.icon, //<Diversity3Outlined {...tabIconStyle} />,
        count: getCount(data, "civilServices"),
        show: hasEmployeeAccess || hasOwnerAccess
    },
    {
        label: "Work Experience",
        icon: workExperienceResource.icon, //<EngineeringOutlined {...tabIconStyle} />,
        count: getCount(data, "workExperiences"),
        show: hasEmployeeAccess || hasOwnerAccess
    },
    {
        label: "Voluntary Work Involvement",
        icon: voluntaryWorkResource.icon, // <EngineeringOutlined {...tabIconStyle} />,
        // hide: true,
        count: getCount(data, "voluntaryWorkHistory"),
        show: hasEmployeeAccess || hasOwnerAccess
    },
    {
        label: "Training Programs",
        icon: trainingAttendedResource.icon, //<EngineeringOutlined {...tabIconStyle} />,
        count: getCount(data, "trainingAttended"),
        show: hasEmployeeAccess || hasOwnerAccess
    },
    {
        label: "Special Skills",
        icon: specialSkillResource.icon, //<EngineeringOutlined {...tabIconStyle} />,
        count: getCount(data, "specialSkills"),
        show: hasEmployeeAccess || hasOwnerAccess
    },
    {
        label: "Achievement/Awards",
        icon: achievementAwardResource.icon, //<EngineeringOutlined {...tabIconStyle} />,
        //hide: true,
        count: getCount(data, "achievementAwards"),
        show: hasEmployeeAccess || hasOwnerAccess
    },
    {
        label: "Character References",
        icon: characterReferenceResource.icon, //<EngineeringOutlined {...tabIconStyle} />,
        //hide: true,
        count: getCount(data, "fam"),
        show: hasEmployeeAccess || hasOwnerAccess
    },
    {
        label: "Assoc Members",
        icon: associationResource.icon, // <EngineeringOutlined {...tabIconStyle} />,
        //hide: true,
        count: getCount(data, "associations"),
        show: hasEmployeeAccess || hasOwnerAccess
    },
    {
        label: "Other Information",
        icon: otherInfoResource.icon, //<EngineeringOutlined {...tabIconStyle} />,
        //hide: true,
        count: getCount(data, "otherInfos"),
        show: hasEmployeeAccess || hasOwnerAccess
    }
];

const payrollTabs = (
    data,
    { hasPayrollAccess, hasEmployeeAccess, hasOwnerAccess }
) => [
    {
        label: "Personal Information",
        icon: PersonOutlineOutlined, //<PersonOutlineOutlined {...tabIconStyle} />,
        count: getCount(data, ""),
        show: true
    },
    {
        label: "Compensation and Benefits",
        icon: CardGiftcard, //<PersonOutlineOutlined {...tabIconStyle} />,
        count: getCount(data, ""),
        show: true
    }
];

const layout = {
    PROFILE: {
        id: "PROFILE",
        description: "Employee Profile"
    },
    PAYROLL: {
        id: "PAYROLL",
        description: "Compensation and Benefits"
    }
};

export default function EmployeeWorkspace(props) {
    const { personId: personIdParm } = useParams();
    const { personId: personIdProps } = props;
    const [view, setView] = useState(layout.PROFILE.id);
    const [visibleTabs, setVisibleTabs] = useState([]);

    const profile = useSelector((state) => state.user.profile);

    const personId = personIdParm || personIdProps;

    const isNew = !personId;

    const userPersonId = profile?.personId;

    const { canView: hasEmployeeAccess } = usePermission("employee");
    const { canView: hasPayrollAccess } = usePermission("payrollEmployee");
    const hasOwnerAccess =
        !isNew &&
        Number.parseInt(userPersonId, 10) === Number.parseInt(personId, 10);

    const {
        loading,
        form,
        activeEmployee,
        updateField,
        person,
        save,
        error,
        isDirty,
        notFound
    } = usePerson(personId);

    const [tabIndex, setTabIndex] = useState(0);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [printOpen, setPrintOpen] = useState(false);

    const navigate = useNavigate();

    const {
        errors: validateErrors,
        validateForm,
        clearFieldError
    } = useFormValidation(personalInfoRules);

    console.log("visibleTabs", { visibleTabs, view });

    useEffect(() => {
        console.log("useEffect", { view });
        const showTabs =
            view === layout.PROFILE.id
                ? profileTabs(person, {
                      hasPayrollAccess,
                      hasEmployeeAccess,
                      hasOwnerAccess
                  }).filter((o) => o?.show)
                : payrollTabs(person, {
                      hasPayrollAccess,
                      hasEmployeeAccess,
                      hasOwnerAccess
                  }).filter((o) => o?.show);

        setVisibleTabs(showTabs);
        setTabIndex(0);
    }, [view, hasEmployeeAccess, hasOwnerAccess, hasOwnerAccess]);

    const theme = useTheme();
    // Mobile-only breakpoint. Change to theme.breakpoints.down("md")
    // if you also want tablets to get the sidebar.
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    // Block navigation if the form is edited (dirty)
    const blocker = useBlocker(
        ({ currentLocation, nextLocation }) =>
            isDirty && currentLocation.pathname !== nextLocation.pathname
    );

    const handleTabChange = (event, newIndex) => {
        setTabIndex(newIndex);
    };

    const handelSave = async () => {
        if (!validateForm(form)) return;
        save();
        if (blocker.state === "blocked") {
            blocker.proceed(); // Navigates to the route clicked in the sidebar
        }
    };

    const handleCancel = () => {
        if (blocker.state === "blocked") {
            blocker.reset(); // Navigates to the route clicked in the sidebar
            navigate(".", { replace: true });
        }
    };

    const handleDisregardChanges = () => {
        if (blocker.state === "blocked") {
            blocker.proceed(); // Navigates to the route clicked in the sidebar
        }
    };

    const handlePrint = async () => {
        if (!person?.id) {
            return;
        }

        try {
            const url = await reportService.getPdfUrl("person-profile", {
                pathParams: [person.id]
            });

            setPdfUrl(url);
            setPrintOpen(true);
        } catch (error) {
            console.error("Failed to generate employee report:", error);
        }
    };

    const handleClosePrint = () => {
        setPrintOpen(false);
    };

    const pageTitle = isNew
        ? "New Employee"
        : (person?.fullName ?? "Loading...");

    const renderActions = () => {
        return (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handelSave}
                    disabled={!isDirty}
                >
                    Save
                </Button>

                <Button
                    variant="outlined"
                    onClick={handlePrint}
                    disabled={!person?.id || loading}
                >
                    Print
                </Button>

                {blocker.state === "blocked" && (
                    <>
                        <Button
                            variant="outlined"
                            color="inherit"
                            onClick={handleCancel}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={handleDisregardChanges}
                            disabled={!isDirty}
                        >
                            Disregard Changes
                        </Button>
                    </>
                )}
            </Box>
        );
    };

    if (notFound && !isNew) {
        return <NotFound />;
    }

    const renderTabContent = () => {
        if (view === layout.PAYROLL.id)
            return (
                <>
                    {tabIndex === 0 && (
                        <PersonalInformationTab
                            form={form}
                            activeEmployee={activeEmployee}
                            updateField={updateField}
                            person={person}
                            isNew={isNew}
                            validateForm={validateForm}
                            validateErrors={validateErrors}
                            clearFieldError={clearFieldError}
                            hasEmployeeAccess={hasEmployeeAccess}
                            hasPayrollAccess={hasPayrollAccess}
                            hasOwnerAccess={hasOwnerAccess}
                        />
                    )}
                    {tabIndex === 1 && (
                        <CompensationTab
                            form={form}
                            activeEmployee={activeEmployee}
                            updateField={updateField}
                            person={person}
                            /*validateForm={validateForm}
                            validateErrors={validateErrors}
                            clearFieldError={clearFieldError}
                            hasEmployeeAccess={hasEmployeeAccess}
                            hasPayrollAccess={hasPayrollAccess}
                            hasOwnerAccess={hasOwnerAccess}*/
                        />
                    )}
                </>
            );

        return (
            <>
                {tabIndex === 0 && (
                    <PersonalInformationTab
                        form={form}
                        activeEmployee={activeEmployee}
                        updateField={updateField}
                        person={person}
                        isNew={isNew}
                        validateForm={validateForm}
                        validateErrors={validateErrors}
                        clearFieldError={clearFieldError}
                        hasEmployeeAccess={hasEmployeeAccess}
                        hasPayrollAccess={hasPayrollAccess}
                        hasOwnerAccess={hasOwnerAccess}
                    />
                )}
                {tabIndex === 1 && (
                    <FamilyBackgroundTab
                        form={form}
                        activeEmployee={activeEmployee}
                        updateField={updateField}
                        person={person}
                    />
                )}
                {tabIndex === 2 && (
                    <EducationalBackgroundTab
                        form={form}
                        activeEmployee={activeEmployee}
                        updateField={updateField}
                        person={person}
                    />
                )}
                {tabIndex === 3 && (
                    <CivilServiceTab
                        form={form}
                        activeEmployee={activeEmployee}
                        updateField={updateField}
                        person={person}
                    />
                )}
                {tabIndex === 4 && (
                    <WorkExperienceTab
                        form={form}
                        activeEmployee={activeEmployee}
                        updateField={updateField}
                        person={person}
                    />
                )}
                {tabIndex === 5 && (
                    <VoluntaryInvolvementTab
                        form={form}
                        activeEmployee={activeEmployee}
                        updateField={updateField}
                        person={person}
                    />
                )}
                {tabIndex === 6 && (
                    <TrainingAttendedTab
                        form={form}
                        activeEmployee={activeEmployee}
                        updateField={updateField}
                        person={person}
                    />
                )}
                {tabIndex === 7 && (
                    <SpecialSkillsTab
                        form={form}
                        activeEmployee={activeEmployee}
                        updateField={updateField}
                        person={person}
                    />
                )}
                {tabIndex === 8 && (
                    <AchievementAwards
                        form={form}
                        activeEmployee={activeEmployee}
                        updateField={updateField}
                        person={person}
                    />
                )}
                {tabIndex === 9 && (
                    <CharacterReferencesTab
                        form={form}
                        activeEmployee={activeEmployee}
                        updateField={updateField}
                        person={person}
                    />
                )}
                {tabIndex === 10 && (
                    <AssociationTab
                        form={form}
                        activeEmployee={activeEmployee}
                        updateField={updateField}
                        person={person}
                    />
                )}
            </>
        );
    };
    const renderLoading = () => {
        return (
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    width: "100%",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)"
                }}
            >
                <Box sx={{ m: 1, position: "relative" }}>
                    <Fab color="primary" aria-label="loading">
                        <HourglassBottom sx={{ zIndex: 2 }} />
                        <CircularProgress
                            thickness={4}
                            size={68}
                            sx={{
                                color: "#e18f8a",
                                position: "absolute",
                                top: -6,
                                left: -6,
                                zIndex: 1
                            }}
                        />
                    </Fab>
                </Box>
            </Box>
        );
    };
    const renderTopMenu = () => {
        return (
            <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
                <DButton
                    sm
                    onClick={() => setView(layout.PROFILE.id)}
                    fullWidth={false}
                >
                    {layout.PROFILE.description}
                </DButton>
                {(hasPayrollAccess || hasEmployeeAccess) && (
                    <DButton
                        sm
                        onClick={() => setView(layout.PAYROLL.id)}
                        fullWidth={false}
                    >
                        {layout.PAYROLL.description}
                    </DButton>
                )}
            </Box>
        );
    };

    return (
        <Container maxWidth="xl" sx={{ p: 2 }}>
            {loading && renderLoading()}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                {/* Top Profile Header Card */}
                <EmployeeHeader
                    form={form}
                    updateField={updateField}
                    person={person}
                    isNew={isNew}
                    renderActions={renderActions}
                />
                {renderTopMenu()}

                {isMobile ? (
                    /* ---------- MOBILE: icon-only sidebar layout ---------- */
                    <Paper
                        variant="outlined"
                        sx={{ display: "flex", alignItems: "stretch" }}
                    >
                        <Box
                            sx={{
                                borderRight: 1,
                                borderColor: "divider",
                                flexShrink: 0,
                                width: 64
                            }}
                        >
                            <Tabs
                                orientation="vertical"
                                value={tabIndex}
                                onChange={handleTabChange}
                                variant="scrollable"
                                aria-label="Employee Workspace Tabs"
                                sx={{
                                    "& .MuiTabs-indicator": {
                                        left: 0,
                                        right: "auto",
                                        width: 3
                                    },
                                    "& .MuiTab-root": {
                                        minHeight: 48,
                                        minWidth: 0,
                                        px: 1
                                    }
                                }}
                            >
                                {visibleTabs.map((tab, index) => {
                                    const Icon =
                                        tab.icon || ConstructionOutlined;
                                    return (
                                        <Tooltip
                                            key={index}
                                            title={tab.label}
                                            placement="right"
                                        >
                                            <Tab
                                                icon={
                                                    <Icon {...tabIconStyle} />
                                                }
                                            />
                                        </Tooltip>
                                    );
                                })}
                            </Tabs>
                        </Box>

                        <Box sx={{ p: 3, flexGrow: 1, minWidth: 0 }}>
                            {renderTabContent()}

                            {error && (
                                <Box sx={{ mt: 3 }}>
                                    <Alert severity="error">{error}</Alert>
                                </Box>
                            )}
                        </Box>
                    </Paper>
                ) : (
                    /* ---------- DESKTOP: original horizontal tabs ---------- */
                    <Paper variant="outlined">
                        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                            <Tabs
                                value={tabIndex}
                                onChange={handleTabChange}
                                aria-label="Employee Workspace Tabs"
                                variant="scrollable"
                                scrollButtons="auto"
                                textColor="primary"
                                indicatorColor="primary"
                            >
                                {visibleTabs.map((tab, index) => {
                                    const label = (
                                        <>
                                            {tab.label}
                                            {tab.count}
                                        </>
                                    );
                                    const Icon =
                                        tab.icon || ConstructionOutlined;
                                    return (
                                        <Tab
                                            {...tab}
                                            icon={<Icon {...tabIconStyle} />}
                                            label={label}
                                            key={index}
                                            iconPosition="start"
                                        />
                                    );
                                })}
                            </Tabs>
                        </Box>

                        <Box sx={{ p: 3 }}>
                            {renderTabContent()}

                            {error && (
                                <Box sx={{ p: 3, pt: 0 }}>
                                    <Alert severity="error">{error}</Alert>
                                </Box>
                            )}
                        </Box>
                    </Paper>
                )}
            </Box>

            {/* Unsaved Changes Dialog */}
            <Dialog
                open={blocker.state === "blocked"}
                onClose={() => blocker.proceed()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                role="alertdialog"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        You have unsaved changes. Would you like to save them
                        before leaving this page?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>{renderActions()}</DialogActions>
            </Dialog>
            {printOpen && pdfUrl && (
                <PdfReportViewer
                    open={printOpen}
                    onClose={handleClosePrint}
                    fileUrl={pdfUrl}
                />
            )}
        </Container>
    );
}
